export default __webpack_public_path__ + "static/invest-public-health-healthcare-accomplishment-3e-a100ba5de0a199551f2b9cf7add670a0.webp";